require('./hireCardMetallicError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');

class hireCardMetallicError extends React.Component {
    buildTexts() {
        const { isErrorAvailableAccounts, immHireCardMetallic, hireRestrictionFlag } = this.props;
        let errorMsg = immHireCardMetallic.get('errorMsg');

        let titleKey;
        let textElement;

        if (isErrorAvailableAccounts) {
            titleKey = 'hireCardMetallic-errorTitleGeneric';
            textElement = <FormattedText value="hireCardMetallic-notAvailableAccounts" />;
        } else if (!!errorMsg) {
            titleKey = 'hireCardMetallic-errorTitleNotAllowed';
            textElement = <FormattedText value={`hireDebitErrors-${errorMsg}`} />;
        } else {
            titleKey = 'hireCardMetallic-errorTitleGeneric';
            textElement = <FormattedText value="hireCardMetallic-errorTextGeneric" />;
        }
        if (isErrorAvailableAccounts && __CONTACT_CENTER__) {
            titleKey = 'hireCardMetallic-errorTitleNotAvailableAccounts';
            textElement = <FormattedText value="hireCards-errorTextNotAvailableAccounts" />;
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
        }
        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey, isErrorAvailableAccounts } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }: isErrorAvailableAccounts && __CONTACT_CENTER__
            ?
                {
                    label: (
                        <FormattedText
                            format="uppercase"
                            value="hireCards-backButtonLabel"
                        />
                    ),
                    url: '/myprofile/cards'
                }
            :
                {
                    label: (
                        <FormattedText
                            format="uppercase"
                            value="hireCardMetallic-errorBackButtonText"
                        />
                    ),
                    url: '/myprofile/global'
                }
                const cancleButton ={
                    label: (
                        <FormattedText
                            value="hireCard-errorRestrictionCancleButtonText"
                        />
                    ),
                    url: '/myprofile/cards'
                    };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
            >
                <article className="hire-card-metallic-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

hireCardMetallicError.propTypes = {
    isErrorAvailableAccounts: PropTypes.bool,
    immHireCardMetallic: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

hireCardMetallicError.defaultProps =
{
    hireRestrictionFlag : false
}
module.exports = hireCardMetallicError;
